'use strict';

import React, { PropTypes } from 'react';
import PageControls from '../molecules/PageControls';
import BackColorMixin from '../mixins/BackColorMixin';
import Button from '../atoms/Button';
import BtnGroup from '../molecules/BtnGroup';
import ZineActionCreators from '../actions/ZineActionCreators';
import createStoreMixin from '../mixins/createStoreMixin';
import ZineDraftStore from '../stores/ZineDraftStore';
import UserStore from '../stores/UserStore';
import ContextMenuTypes from '../constants/ContextMenuTypes';
import ContextMenuActionCreators from '../actions/ContextMenuActionCreators';
import PureRenderMixin from '../mixins/PureRenderMixin';
import ZineStatus from '../constants/ZineStatus';
import Icon from '../atoms/Icon';

const ZineEditPageControls = React.createClass({
  mixins: [BackColorMixin, createStoreMixin(ZineDraftStore), PureRenderMixin],

  contextTypes: {
    router: PropTypes.func
  },

  getStateFromStores() {
    const previouslyVisibleZine = this.state && this.state.zine || null;
    return {
      zine: ZineDraftStore.getActiveDraft() || previouslyVisibleZine
    };
  },

  render() {
    const { zine } = this.state;
    if (!zine) {
      return <PageControls />;
    }

    const isProAccount = UserStore.isAuthenticated() && UserStore.getMe().isProAccount;
    const isUnlisted = zine.status === ZineStatus.UNLISTED;
    const textColor = zine.backColor;
    const backColor = this.getTextColor(zine.backColor) === 'dark' ?
      '2e2f33' :
      'ffffff';

    return (
      <PageControls textColor={textColor}
                    backColor={backColor}>
        <PageControls.Container>
          <Button size='large'
                  color='black'
                  overlay
                  context='PageControls'
                  onClick={this.handleColorClick}>
            Color
            <Icon name='arrowUp'
                  mode='stroke'
                  size='xsmall'
                  margin='left' />
          </Button>
        </PageControls.Container>

        {isProAccount && zine.isNew &&
          <PageControls.Separator />
        }

        {isProAccount && zine.isNew &&
          <PageControls.Container>
            <Button size='large'
                    color='black'
                    overlay
                    context='PageControls'
                    onClick={this.handleStatusClick}>
              <Icon name={isUnlisted ? 'eyeCrossed' : 'eye'}
                    mode={isUnlisted ? 'fill' : 'stroke'}
                    size='small'/>
              {isUnlisted ? 'Secret' : 'Public'}
              <Icon name='arrowUp'
                    mode='stroke'
                    size='xsmall'
                    margin='left' />
            </Button>
          </PageControls.Container>
        }

        <PageControls.Separator />

        <PageControls.Container>
          <BtnGroup>
            {!zine.isNew &&
              <Button size='large'
                      color='black'
                      overlay
                      split
                      context='PageControls'
                      onClick={this.handleCancelClick}>
                Cancel
              </Button>
            }

            <Button size='large'
                    color='green'
                    fill
                    split={!zine.isNew}
                    context='PageControls'
                    onClick={this.handleSaveClick}>
              {zine.isNew ? 'Create' : 'Save'}
            </Button>
          </BtnGroup>
        </PageControls.Container>
      </PageControls>
    );
  },

  handleColorClick(e) {
    const el = e.target;
    const color = this.state.zine.backColor;

    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.ZINE_COLOR_PICKER, el, {
      previousColor: color
    });
  },

  handleStatusClick(e) {
    const el = e.target;
    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.ZINE_STATUS_PICKER, el);
  },

  handleCancelClick() {
    const { router: { goBack } } = this.context;

    ZineActionCreators.destroyZineDraft();

    if (this.state.zine.isNew) {
      goBack();
    }
  },

  handleSaveClick() {
    const { zine } = this.state;

    if (zine.isNew) {
      ZineActionCreators.createZine(this.state.zine);
    } else {
      ZineActionCreators.updateZine(this.state.zine);
    }
  }
});

export default ZineEditPageControls;



/** WEBPACK FOOTER **
 ** ./pageControls/ZineEditPageControls.jsx
 **/